import React from 'react';
import { getClearingTasks } from '~/javascripts/admin/actions/clearing';
import { formatDate } from '~/javascripts/admin/utils';
import { createBadge } from '../../atoms/Badge';
import Table from '../../atoms/Table';
import SeqPager from '../../organisms/SeqPager';

type Props = {
  clearingTasks?: Awaited<ReturnType<typeof getClearingTasks>>;
  onChangePage: (paginatedLink: string | null) => void;
};

type Header = {
  label: string;
  size: number;
  align?: 'center' | 'justify' | 'left' | 'right';
};

const HEADERS: Header[] = [
  { label: '状態', size: 1 },
  { label: '締め日', size: 1 },
  { label: '開始日時', size: 2 },
  {
    label: '完了日時',
    size: 2,
  },
  { label: '実行者', size: 1 },
  { label: '件数', size: 1, align: 'right' },
  { label: '', size: 4 },
];

const ClearingTaskStatusBadge = createBadge(
  {
    done: { label: '実行済' },
    error: { label: 'エラー', bgColor: '#D75F48' },
    processing: { label: '処理中', bgColor: '#3C86C9' },
    submitted: { label: '処理中', bgColor: '#3C86C9' },
  },
  {
    styles: `
      &[status="processing"],
      &[status="submitted"] {
        opacity: 0.5;
      }
    `,
  }
);

const ListTable = ({ clearingTasks, onChangePage }: Props) => {
  return (
    <Table>
      <Table.Header>
        <Table.Row>
          {HEADERS.map((h) => (
            <Table.Cell size={h.size} align={h.align}>
              {h.label}
            </Table.Cell>
          ))}
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {clearingTasks?.rows?.map((c) => (
          <Table.Row key={c.id}>
            <Table.Cell wordBreak="keep-all">
              <ClearingTaskStatusBadge status={c.status} />
            </Table.Cell>
            <Table.Cell wordBreak="keep-all">{formatDate(c.closing_date, 'YYYY/MM/DD')}</Table.Cell>
            <Table.Cell wordBreak="keep-all">{formatDate(c.created_at)}</Table.Cell>
            <Table.Cell wordBreak="keep-all">{c.done_at ? formatDate(c.done_at) : ''}</Table.Cell>
            <Table.Cell wordBreak="break-word">{c.operator.name}</Table.Cell>
            <Table.Cell wordBreak="keep-all" align="right">
              {c.count ?? ''}
            </Table.Cell>
            <Table.Cell />
          </Table.Row>
        ))}
      </Table.Body>
      <Table.Footer>
        <Table.Row noBorder>
          <Table.Cell colSpan={HEADERS.length} align="center" styles={{ paddingTop: '16px' }}>
            {clearingTasks && (
              <SeqPager
                prev={clearingTasks.prev}
                next={clearingTasks.next}
                onChangePage={onChangePage}
              />
            )}
          </Table.Cell>
        </Table.Row>
      </Table.Footer>
    </Table>
  );
};

export default ListTable;
